import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PlanList from "../../Components/PlanList";
import OperatingSystem from "../../Components/OperatingSystem";
import { ScrollToPlans } from "../../utils/ScrollToPlan";
import sal from "sal.js";
import { Helmet } from "@dr.pogodin/react-helmet";
import MinPlanPrice from "../../Components/MinPlanPrice";
import CouponScrollBar from "../../Components/CouponScrollBar";

export default function DedicatedServerNewYork() {
  const [applyPaddingClass, setApplyPaddingClass] = useState(false);
  useEffect(() => {
    document.title = "Secure Dedicated Server New York Hosting with 24/7 Support";
    sal();
  }, []);
  const handlePlanClick = () => {
    ScrollToPlans(".price-plan-section");
    };
  return (
    <>
        <Helmet>
            <title>Secure Dedicated Server New York Hosting with 24/7 Support</title>
            <meta name="description" content="Secure, fast, and fully managed dedicated server New York hosting, perfect for businesses that demand high performance, reliability, maximum uptime and support." />
            <meta name="keywords" content="Dedicated Server Hosting, Dedicated Server, Best Dedicated Server Hosting, Dedicated Server New York" />
            <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/dedicated-server-new-york`} />
            <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/dedicated-server-new-york`} />
            <meta property="og:title" content="Dedicated Server New York: The Finest Web Hosting Near You" />
            <meta property="og:description" content="Enhance your business with the help of Dedicated Server New York hosting. Get high-speed access, and complete access-all backed by powerful infrastructure" />
        </Helmet>
        <section className="banner-bg bg-dark ssl-banner">
            <div className="container">
                <div className="row align-items-center g-4">
                    <div className="col-lg-6">
                        <div className="pb-40">
                        <span className="fs-18 fw-bold text-primary mb-2 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">NY Power Hub</span>
                        <h1 className="text-white mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">With Dedicated Server New York Don’t Do Buffering</h1>
                        <p className="text-white mb-8 max-text-60 text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Stop letting tech hold you back during high traffic with our dedicated server New York. Host like an expert with complete access, close-to-client performance, and big-city power without the struggle.
                        </p>
                        <div className="d-flex align-items-center flex-wrap gap-4">
                            <button onClick={handlePlanClick} className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded sal-animate btn-height" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                <span className="btn-arrow__text">
                                    View All Plans
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </button>
                            <MinPlanPrice category="customizeddny" />
                        </div>
                        <span className="d-block fs-14 text-white text-opacity-75 mt-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Get 100% Refund Within 30 Days* <sup><small className="text-opacity-50 tnc-text">T&Cs</small></sup></span>
                        </div>
                    </div>
                    <div className="col-lg-6 col-xxl-6 ipad-mt"><div className="cloud-hero__img sal-animate" data-sal="fade" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine"><img alt="image" className="img-fluid" src="/images/with-dedicated-server-new.webp"/></div></div>
                </div>
            </div>
        </section>
        <div className="container responsive-pt-60 pb-100">
            <div className="row">
                <div className="col-12">
                    <div className="bg-grey pt-80 pb-80 px-5 px-md-8 px-xl-12 rounded-4 position-relative z-1 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <div className="row g-4 align-items-center">
                            <div className="col-md-10 col-lg-10 col-xl-5">
                                <h2>
                                    Your Perfect New York Server Solution Awaits!
                                </h2>
                                <p className="mb-8 text-opacity-75">
                                    Need high power, speed, and full control? Our dedicated server New York offer everything you’ve been looking for-no restrictions. Ready to boost your business? Let’s make it happen.
                                </p>
                            </div>
                            <div className="col-xl-7">
                                <div className="row g-4 g-xl-0 feature-card">
                                    <div className="col-md-6 feature-card__list">
                                        <div className="feature-card__is border border-little-light border-opacity-25 rounded-3">
                                            <div className="mb-4">
                                                <img src="images/unleash-high.webp" alt="image" className="img-fluid" />
                                            </div>
                                            <h6 className="mb-4">
                                                Unleash High Power
                                            </h6>
                                            <p className="mb-0 text-opacity-50">
                                                Harness total control with our SSD-based dedicated servers. You decide everything. Complete freedom to personalize your way with our server.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-6 feature-card__list">
                                        <div className="feature-card__is border border-little-light border-opacity-25 rounded-3">
                                            <div className="mb-4">
                                                <img src="images/10-gbps.webp" alt="image" className="img-fluid" />
                                            </div>
                                            <h6 className="mb-4">
                                                10 Gbps Speed 
                                            </h6>
                                            <p className="mb-0 text-opacity-50">
                                               Think about your resource-heavy sites & apps running with our dedicated server. With speeds up to 10 Gbps, your server is all set to manage everything.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-6 feature-card__list">
                                        <div className="feature-card__is border border-little-light border-opacity-25 rounded-3">
                                            <div className="mb-4">
                                                <img src="images/your-server.webp" alt="image" className="img-fluid" />
                                            </div>
                                            <h6 className="mb-4">
                                                Your Server, Your Charge
                                            </h6>
                                            <p className="mb-0 text-opacity-50">
                                                You’re in charge. With New York dedicated server hosting, you get complete admin rights to tweak, install, or uninstall anything that you want to.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-6 feature-card__list">
                                        <div className="feature-card__is border border-little-light border-opacity-25 rounded-3">
                                            <div className="mb-4">
                                                <img src="images/turnkey-hosting.webp" alt="image" className="img-fluid" />
                                            </div>
                                            <h6 className="mb-4">
                                                Turnkey Hosting, Fast
                                            </h6>
                                            <p className="mb-0 text-opacity-50">
                                                Whatever you want-databases, SSH access, file access, and more. Our New York dedicated server hosting is engineered to fit your business.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-6 feature-card__list">
                                        <div className="feature-card__is border border-little-light border-opacity-25 rounded-3">
                                            <div className="mb-4">
                                                <img src="images/all-setup.webp" alt="image" className="img-fluid" />
                                            </div>
                                            <h6 className="mb-4">
                                                 All Setup Possibilities
                                            </h6>
                                            <p className="mb-0 text-opacity-50">
                                                Get your dedicated server New York, & your server is ready within no time! We’ve got your OS and management panel prepared so you can rule.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-6 feature-card__list">
                                        <div className="feature-card__is border border-little-light border-opacity-25 rounded-3">
                                            <div className="mb-4">
                                                <img src="images/tailored-for.webp" alt="image" className="img-fluid" />
                                            </div>
                                            <h6 className="mb-4">
                                                Tailored for Your Goals
                                            </h6>
                                            <p className="mb-0 text-opacity-50">
                                                No shared resources means no downtime. Your dedicated server New York stays quick, with faster load times and reliable performance.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <img src="images/vps-feature-shape.png" alt="image" className="img-fluid d-none d-xl-block position-absolute left-0 top-0 z-n1 filtered-image" />
                    </div>
                </div>
            </div>
        </div>
        <section className="price-plan-section pt-100 pb-100">
            <CouponScrollBar setPaddingClass={setApplyPaddingClass} />
            <div className={`pb-40 ${applyPaddingClass ? "plan-extra-top-padding" : ""}`}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-8">
                            <div className="text-center">
                                <span className="section-title-dark style-bg fadeInUp">Our Plans</span>
                                <h2 className="theme-title-text-white" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine"> Own the Setup. Rule the Server.</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <PlanList category={'customizeddny'}/>
        </section>
        
        <section className="why-area-one bg-dark pt-60 pb-100 position-relative z-1">
        <div className="container">
            <div className="row align-items-center justify-content-between">
                <div className="col-xl-7">
                    <h2 className="text-white sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Game-Changer Web Hosting New York for Big Goals!</h2>
                </div>
            </div>
            <div className="mt-8">
                <div className="row g-4">
                    <div className="col-xl-3 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                        <div className="why-card px-6 py-9 rounded-3 transition h-100">
                            <img src="images/fast-track.webp" alt="image" className="img-fluid"/>
                            <img src="images/fast-track-dark.webp" alt="image" className="img-fluid dark"/>
                            <h6 className="text-white mt-7">Fast Track to Success</h6>
                            <p className="text-white text-opacity-75 mb-0">Our servers, with SSD storage, DDR4 memory, and Intel and AMD processors, make sure that your site runs seamlessly.</p>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <div className="why-card px-6 py-9 rounded-3 transition h-100">
                            <img src="images/always-on-never.webp" alt="image" className="img-fluid"/>
                            <img src="images/always-on-never-dark.webp" alt="image" className="img-fluid dark"/>
                            <h6 className="text-white mt-7">Always-On, Never Off</h6>
                            <p className="text-white text-opacity-75 mb-0">Get your business up and running in no time! With the help of one tap, install CMS systems like Magento, PrestaShop, & Drupal. </p>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                        <div className="why-card px-6 py-9 rounded-3 transition h-100">
                            <img src="images/no-wait.webp" alt="image" className="img-fluid"/>
                            <img src="images/no-wait-dark.webp" alt="image" className="img-fluid dark"/>
                            <h6 className="text-white mt-7">No Wait, Just Launch</h6>
                            <p className="text-white text-opacity-75 mb-0">Sick of waiting for pages to load slowly? Our dedicated server New York deliver high speeds, keeping your site seamless and live.</p>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                        <div className="why-card px-6 py-9 rounded-3 transition h-100">
                            <img src="images/power-that.webp" alt="image" className="img-fluid"/>
                            <img src="images/power-that-dark.webp" alt="image" className="img-fluid dark"/>
                            <h6 className="text-white mt-7">Power That Boom</h6>
                            <p className="text-white text-opacity-75 mb-0">With our dedicated server New York use enterprise-level hardware, offering high processing power that boosts. </p>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                        <div className="why-card px-6 py-9 rounded-3 transition h-100">
                            <img src="images/full-access-full.webp" alt="image" className="img-fluid"/>
                            <img src="images/full-access-full-dark.webp" alt="image" className="img-fluid dark"/>
                            <h6 className="text-white mt-7">Full Access, Full Flex</h6>
                            <p className="text-white text-opacity-75 mb-0">With our trustworthy cloud infrastructure, get server configurations and 24/7 support to make sure that your site stays. </p>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <div className="why-card px-6 py-9 rounded-3 transition h-100">
                            <img src="images/full-root.webp" alt="image" className="img-fluid"/>
                            <img src="images/full-root-dark.webp" alt="image" className="img-fluid dark"/>
                            <h6 className="text-white mt-7">Full Root Access</h6>
                            <p className="text-white text-opacity-75 mb-0">Host Dedicated server with full root access gives you control over your server & the ability to customise, manage, & configure. </p>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                        <div className="why-card px-6 py-9 rounded-3 transition h-100">
                            <img src="images/custom-vibes.webp" alt="image" className="img-fluid"/>
                            <img src="images/custom-vibes-dark.webp" alt="image" className="img-fluid dark"/>
                            <h6 className="text-white mt-7">Custom Vibes Only</h6>
                            <p className="text-white text-opacity-75 mb-0">With complete root access, you can flawlessly personalize, handle, and install everything you want, giving you total control.</p>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                        <div className="why-card px-6 py-9 rounded-3 transition h-100">
                            <img src="images/keep-your-inbox.webp" alt="image" className="img-fluid"/>
                            <img src="images/keep-your-inbox-dark.webp" alt="image" className="img-fluid dark"/>
                            <h6 className="text-white mt-7">Keep Your Inbox Clean</h6>
                            <p className="text-white text-opacity-75 mb-0">Bored with spam? Our cutting-edge filters and antivirus software will always keep your inbox secure and free.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </section>

        <section className="pt-100 pb-60">
            <div className="container">
                <div className="row">
                    <div className="col-xl-6 col-lg-10">
                        <h2 className="mb-8">Lag? Not in Our Vocabulary: Go Live with Us</h2>
                    </div>
                </div>
                <div className="row align-items-end g-4">
                    <div className="col-xl-6">
                        <img src="images/lag-not-in-our.webp" alt="image" className="img-fluid full-width-img" />
                    </div>
                    <div className="col-xl-6 ipad-pro-mt">
                        <div className="">
                            
                            <p className="mb-5">Worried about slow loads and server issues? Infinitive Host's New York dedicated server is engineered for high speed, full access, and no lag vibes.
                            </p>

                            <div className="row g-4">
                                <div className="col-md-6">
                                    <div className="bg-white p-8 rounded-4 h-100">
                                        <img src="images/worldwide-reach.webp" alt="icon" className="img-fluid mb-4" />
                                        <h6 className="mb-3">
                                        Worldwide Reach, High Speed</h6>
                                        <p className="mb-0">Ever wonder why your site feels slow? It’s probably not you-it’s your server. With data centers globally, your content loads quickly.</p>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="bg-white p-8 rounded-4 h-100">
                                        <img src="images/peace-of-mind.webp" alt="icon" className="img-fluid mb-4" />
                                        <h6 className="mb-3">Peace of Mind, Locked In</h6>
                                        <p className="mb-0">Stressed about unexpected hacks or data breaches? Don’t worry. Our dedicated server New York gives you the keys to your fortress.</p>
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <div className="bg-white p-7 rounded-4 d-flex align-items-center flex-wrap flex-sm-nowrap gap-6 position-relative z-1">
                                        <img src="images/event-8-shape.png" alt="image" className="img-fluid position-absolute top-0 end-0 z-n1" />
                                        <img src="images/uptime-that.webp" alt="image" className="img-fluid" />
                                        <div>
                                            <h6 className="mb-3">Uptime That Has Your Back</h6>
                                            <p className="mb-0"> Website down during high traffic hours? That’s a horrible nightmare. We offer a 99.9% uptime guarantee so your business stays strong, even at the time of peak traffic.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <OperatingSystem/>
        <section className="pt-60 pb-100">
            <div className="container">
                <div className="cta-wrapper-one pt-60 pb-60 px-6 rounded-3">
                    <div className="row justify-content-center">
                        <div className="col-xxl-7 col-xl-9">
                            <div className="d-flex justify-content-center sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                                <div className="px-3 py-1 border border-primary rounded d-inline-flex align-items-center gap-2">
                                    <div className="w-2 h-2 rounded-circle bg-primary"></div>
                                    <small className="text-primary fw-bold">Zero Delay & Interruption</small>
                                </div>
                            </div>
                            <div className="text-center mt-5">
                                <h2 className="mb-5 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Your audience won’t wait!!</h2>
                                <p className="mb-8 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Host with high power. Get a New York dedicated server and leave all delays behind. </p>
                            </div>
                            <div className="d-flex align-items-center justify-content-center gap-4 flex-wrap flex-md-nowrap sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                                <button onClick={handlePlanClick} className="btn btn-primary btn-arrow btn-arrow-md btn-lg fs-14 fw-medium rounded btn-height">
                                    <span className="btn-arrow__text">
                                        Start Now
                                        <span className="btn-arrow__icon">
                                            <i className="fa-solid fa-arrow-right"></i>
                                        </span>
                                    </span>
                                </button>
                                <Link to="/frequently-asked-questions" className="btn btn-dark btn-arrow btn-arrow-md btn-lg fs-14 fw-medium rounded btn-height">
                                    <span className="btn-arrow__text">
                                        Learn More
                                        <span className="btn-arrow__icon">
                                            <i className="fa-solid fa-arrow-right"></i>
                                        </span>
                                    </span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  );
}
